import './vendor';

import helpers from './helpers';

import {ieFix} from './vendor/ie-fix';
import {vhFix} from './vendor/vh-fix';

import {actualYear} from './modules/actualYear';
import lazyLoading from './modules/lazyLoading';
import scrollToAnchor from './modules/scrollToAnchor';

import articleScroll from './components/article-scroll';
import backgroundMove from './components/background-move';
import matrix from './components/matrix';
import nav from './components/nav';
import preloader from './components/preloader';
import scroller from './components/scroller';
import showAnimation from './components/show-animation';
import social from './components/social';
import videojs from './components/video';
import chapterFixed from './components/chapterAnimation/scheme/chapter-fixed';

let resizeWidth = null;

const resize = () => {
	if (helpers.isMobile() && innerWidth === resizeWidth) {
		return;
	}

	matrix.resize();
	showAnimation.resize();
	articleScroll.resize();

	if (ScrollTrigger) {
		ScrollTrigger.refresh(true);
	}

	resizeWidth = innerWidth;
};

const init = async () => {
	helpers.$siteContainer.removeClass('is-hidden');

	ieFix();
	vhFix();
	actualYear();

	lazyLoading.init();
	scrollToAnchor.init();

	chapterFixed.prepare();

	await preloader.start();

	backgroundMove.init();
	nav.init();
	showAnimation.init();
	social.init();
	videojs.init();
	scroller.init();

	preloader.finish();

	resizeWidth = innerWidth;

	window.addEventListener('resize', _debounce(resize, 500));
};

init();

